import { BellOutlined, MailOutlined } from '@ant-design/icons';
import { Alert, App, Button, Form, Select, Switch, Tag } from 'antd';
import { useEffect, useState } from 'react';
import { api } from '../../api';
import { ErrorNotice, FormSkeleton, PageHeader, Panel } from '../../components';
import { useLoad } from '../../lib';
import { BackToSettings } from './BackToSettings';

export function EnquiryNotificationSettings() {
  const { message } = App.useApp();
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);
  const { data, error, loading, reload } = useLoad(async () => {
    const [notices, email] = await Promise.all([api('/v1/admin/settings/enquiry-notifications'), api('/v1/admin/settings/email')]);
    return { notices: notices.settings, email: email.settings };
  });
  useEffect(() => { if (data) form.setFieldsValue(data.notices); }, [data, form]);

  async function save(values) {
    setSaving(true);
    try {
      await api('/v1/admin/settings/enquiry-notifications', { method: 'PUT', body: JSON.stringify(values) });
      message.success('Contact notification recipients saved.');
      await reload();
    } catch (err) {
      message.error(err instanceof Error ? err.message : 'Could not save notification settings');
    } finally {
      setSaving(false);
    }
  }

  return <>
    <PageHeader title="Contact notifications" description="Email selected team members whenever the public contact form receives a new enquiry." actions={<BackToSettings />} />
    <ErrorNotice error={error} />
    {data && !data.email.active && <Alert type="warning" showIcon title="SMTP email is not active" description="Configure and enable Settings › Email first. Enquiries are still stored even when notification email cannot be sent." style={{ marginBottom: 20 }} />}
    {loading && !data ? <FormSkeleton sections={2} /> : <Form form={form} layout="vertical" onFinish={save} requiredMark={false}>
      <Panel title="New enquiry email" description="Uses the same SMTP configuration as account OTP email. Each recipient receives a private copy.">
        <div className="form-section">
          <div><h4><BellOutlined /> Send notifications</h4><p>Turning this off stops notification email without affecting the contact form or ADMIN inbox.</p></div>
          <Form.Item name="enabled" valuePropName="checked" label="Email on submission"><Switch /></Form.Item>
        </div>
        <div className="form-section">
          <div><h4><MailOutlined /> Recipients</h4><p>Enter an address and press Enter. You can add up to 20 team email addresses.</p></div>
          <Form.Item name="recipients" label="Notification emails" rules={[{ validator: (_, values = []) => values.every((value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) ? Promise.resolve() : Promise.reject(new Error('Remove invalid email addresses.')) }]}>
            <Select mode="tags" tokenSeparators={[',', ' ']} placeholder="admin@example.com" maxCount={20} suffixIcon={null} />
          </Form.Item>
        </div>
        <div className="form-actions"><Button type="primary" htmlType="submit" loading={saving}>Save notifications</Button>{data?.email.active ? <Tag color="success" variant="filled">SMTP ready</Tag> : <Tag color="warning" variant="filled">SMTP not ready</Tag>}</div>
      </Panel>
    </Form>}
  </>;
}
